module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    },
    attrs: {
      "append-to-body": "",
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "veteranDetail",
    attrs: {
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('div', {
    staticClass: "veteranBaseInfo"
  }, [(_vm.form.id > 0) ? _c('div', {
    staticClass: "veteranPhoto"
  }, [_c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.form.photo
    }
  }), _vm._v(" "), (_vm.form.sex == 0 || _vm.form.sex == false) ? _c('img', {
    staticClass: "sex",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png"
    }
  }) : _c('img', {
    staticClass: "sex",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.form.id > 0) ? _c('div', {
    staticClass: "veteranName"
  }, [_vm._v(_vm._s(_vm.form.name)), _c('span', [_vm._v(_vm._s(_vm.form.age) + "岁")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "veteranHardInfo"
  }, [_vm._v("困难说明")]), _vm._v(" "), _c('div', {
    staticClass: "veteranHardInfoContent",
    domProps: {
      "innerHTML": _vm._s(_vm.form.hardInfo)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "veteranFile"
  }, _vm._l((_vm.form.files), function(item, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": item
      }
    })
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5971cfc6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkout/components/VeteranDetail.vue
// module id = 768
// module chunks = 2